import { createContext, useContext } from 'react';

interface EligibilityBannerContextValue {
  visible: boolean;    // should the banner render right now?
  dismissed: boolean;  // has the user explicitly closed it? (= !visible)
  dismiss: () => void;
}

export const EligibilityBannerContext = createContext<EligibilityBannerContextValue>({
  visible: true,
  dismissed: false,
  dismiss: () => {},
});

export const useEligibilityBanner = () => useContext(EligibilityBannerContext);
